import { action } from './index';

export const LOAD_INIT_MESSAGE = 'LOAD_INIT_MESSAGE';
export const INIT_MESSAGE = 'INIT_MESSAGE';
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_FILE_MESSAGE = 'SEND_FILE_MESSAGE';
export const CONVERSATION_ERROR = 'CONVERSATION_ERROR';
export const READ_MESSAGE = 'READ_MESSAGE';
export const MESSAGE_WAS_READ = 'MESSAGE_WAS_READ';
export const CREATE_NEW_CONVERSATION = 'CREATE_NEW_CONVERSATION';
export const UPDATE_CONVERSATION_LIST = 'UPDATE_CONVERSATION_LIST';

export const requestInitMessages = ({ params }) => action(LOAD_INIT_MESSAGE, { params });

export const initMessages = data => action(INIT_MESSAGE, data);
export const receiveMessage = data => action(RECEIVE_MESSAGE, data);
export const sendMessage = data => action(SEND_MESSAGE, data);
export const sendFileMessage = data => action(SEND_FILE_MESSAGE, data);
export const readMessage = data => action(READ_MESSAGE, data);

export const conversationError = data => action(CONVERSATION_ERROR, data);
export const createNewConversation = data => action(CREATE_NEW_CONVERSATION, data);
